export default __webpack_public_path__ + "static/media/Res_Amazon-EC2_Instance_48_Light.7af0c636.svg";